/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteResponseData,
  GetSiteResponseDataFromJSON,
  GetSiteResponseDataFromJSONTyped,
  GetSiteResponseDataToJSON
} from './GetSiteResponseData'

/**
 *
 * @export
 * @interface UploadHeaderLogoSiteResponse
 */
export interface UploadHeaderLogoSiteResponse {
  /**
   *
   * @type {number}
   * @memberof UploadHeaderLogoSiteResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteResponseData}
   * @memberof UploadHeaderLogoSiteResponse
   */
  data?: GetSiteResponseData
}

export function UploadHeaderLogoSiteResponseFromJSON(json: any): UploadHeaderLogoSiteResponse {
  return UploadHeaderLogoSiteResponseFromJSONTyped(json, false)
}

export function UploadHeaderLogoSiteResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UploadHeaderLogoSiteResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteResponseDataFromJSON(json['data'])
  }
}

export function UploadHeaderLogoSiteResponseToJSON(value?: UploadHeaderLogoSiteResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteResponseDataToJSON(value.data)
  }
}
